import React from 'react';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import RightPanel from './rightPanel.js';
import { List } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function ContentSelfProvisionWA(props) {
  const headingClass = 'text-size-ml';

  return (
    <Modal show={props.showWaitingAreaWelcomeModal} hideWhenClickAway={false} className="ui modal welcome-waiting-area">
      <PopupHeader
        hideHelp={true}
        title={APP.LANGUAGE.WelcomeWaitingArea.Title}
        subtitle={props.waitingArea.name + ' ' + APP.LANGUAGE.WelcomeWaitingArea.Title2}
      />

      <div className="content">
        <div className="main-ui-container ">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel isMobile={false} />
              </div>
            </div>

            <div>
              <div className="mrtm bold">
                <span className={headingClass}>{APP.LANGUAGE.WelcomeWaitingArea.EmailInfo}</span>
              </div>
              <div className="mrtxs mrbm">
                <span>{APP.LANGUAGE.WelcomeWaitingArea.EmailInfoDetail}</span>
              </div>
              <ul style={{ paddingLeft: '20px' }}>
                <li className="title-sms bold">{APP.LANGUAGE.WelcomeWaitingArea.EmailInfoDetail2}</li>
                <li className="title-sms bold">{APP.LANGUAGE.WelcomeWaitingArea.EmailInfoDetail3}</li>
              </ul>
              <div className="mrtl bold">
                <span className={headingClass}>{APP.LANGUAGE.WelcomeWaitingArea.OpeningHours}</span>
              </div>
              <div className="mrtxs mrbm">
                <span>{APP.LANGUAGE.WelcomeWaitingArea.OpeningHoursDetail}</span>
              </div>
              <div className="mrtl bold">
                <span className={headingClass}>{APP.LANGUAGE.WelcomeWaitingArea.PageContent2}</span>
                <i aria-hidden="true" class=" setting large  icon new-advanced-settings-btn" />
              </div>

              <div className="mrtxs">
                <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.WelcomeWaitingArea.CustomizeWAContent1))}</span>
              </div>
              <div className="mrtxs">{htmlToReactParser.parse(xss(APP.LANGUAGE.WelcomeWaitingArea.List))}</div>

              <div className="mrtm">
                <span>
                  <List>
                    <List.Item>
                      <List.Icon name="checkmark color-button-on-text" />
                      <List.Content className="display-table-cell">
                        {APP.LANGUAGE.WelcomeWaitingArea.EditList1}
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="checkmark color-button-on-text" />
                      <List.Content className="display-table-cell">
                        {APP.LANGUAGE.WelcomeWaitingArea.EditList2}
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="checkmark color-button-on-text" />
                      <List.Content className="display-table-cell">
                        {APP.LANGUAGE.WelcomeWaitingArea.EditList3}
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="checkmark color-button-on-text" />
                      <List.Content className="display-table-cell">
                        {APP.LANGUAGE.WelcomeWaitingArea.EditList4}
                      </List.Content>
                    </List.Item>
                  </List>
                </span>
              </div>
              <div className="mrtxs mrbm">
                <span>{APP.LANGUAGE.WelcomeWaitingArea.CustomeizeWAContentMore}</span>
              </div>
              <div className="mrtl show-on-small-ress">
                <div className="mrtl bold">
                  <span className={headingClass}>
                    {htmlToReactParser.parse(xss(APP.LANGUAGE.WelcomeWaitingArea.HelpHeading))}
                  </span>
                  <img className="ui image helpTopAlignSmall" src={window.APP.IMAGES.HelpIconColor.default} />
                </div>
                <div className="mrtxs mrbm">
                  <p className="color-info  platformName">
                    {APP.LANGUAGE.WelcomeWaitingArea.HelpHeading1.replace(
                      '##platformName##',
                      window.APP.CONFIGURATION.PORTAL.VideoCallPlatformName
                    )}
                  </p>
                </div>
                <span className="color-info mrtm">{APP.LANGUAGE.WelcomeWaitingArea.HelpHeading2}</span>
              </div>
            </div>

            <div className="bottom-rail-with-left-and-right-content mrtl">
              <RightPanel isMobile={true} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
